import { Directive, ElementRef, HostListener, HostBinding, Input } from '@angular/core';
import { HoverState } from '../../../../app.data';

@Directive({
    selector: '[onHover]'
})
export class HoverDirective {

    constructor(
        // private elementRef: ElementRef
    ) { }

    // @Input() state: string = HoverState.in;

    @HostListener('mouseenter') mouseover() {
        // this.renderer.setStyle(this.elementRef.nativeElement, 'background-color', 'blue');
        // this.color = this.highlight;
        console.log('mouseenter');
    }

    @HostListener('mouseleave') mouseleave() {
        // this.renderer.setStyle(this.elementRef.nativeElement, 'background-color', 'transparent');
        // this.color = this.defaultColor;
        console.log('mouseleave');
    } 

    // @HostListener('mouseenter', ['$event'])
    // @HostListener('mouseleave', ['$event'])
    // onHover(event: MouseEvent) {
    //     console.log(this.state);
    //     // const direction = event.type === 'mouseenter' ? HoverState.in : HoverState.out;
    //     // const host = event.target as HTMLElement;
    //     // const w = host.offsetWidth;
    //     // const h = host.offsetHeight;
    //     // const x = (event.pageX - host.offsetLeft - (w / 2)) * (w > h ? (h / w) : 1);
    //     // const y = (event.pageY - host.offsetTop - (h / 2)) * (h > w ? (w / h) : 1);
    //     // const states = ['top', 'right', 'bottom', 'left'];
    //     // const side = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4;
    //     // this.state = `${direction}-${states[side]}`;
    //     // this.state = `${direction}`;
    //     // console.log(this.state);
    // }
}
